import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-devices-placements-v3',
	styleUrls: ['./devices-placements-v3.component.css'],
	templateUrl: './devices-placements-v3.component.html'
})
export class DevicesPlacementsV3Component implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() devicedatatableconfig: string;
	@Input() tertiarykey: string;
	@ViewChild('carousel') carousel: NguCarousel<any>;

	public screenShotsData: any[] = [];
	public showLoad = true;
	public hasData = true;
	public sectionclass: string;
	public colcount: number;
	public previewData: any = {};
	public activeIndex = 0;
	public reloadSubscription;
	public widgetDataSubscription;
	public carouselOne: NguCarouselConfig;

	constructor(protected analyticsService: AnalyticsService) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.devicedatatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.carouselOne = {
			custom: 'banner',
			grid: { xs: 1, sm: 3, md: 3, lg: 3, all: 0 },
			loop: true,
			point: {
				hideOnSingleSlide: true,
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.tertiarykey).subscribe((res: any) => {
			this.screenShotsData = [];
			this.showLoad = false;
			if (res.success && res.data.length > 0) {
				this.hasData = true;
				this.processResponseData(res.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		for (const response of responseData) {
			const obj = {
				completeURL: response.full_url,
				date: response.date,
				imageURL: response.path,
				url: response.url
			};
			this.screenShotsData.push(obj);
		}
		this.previewScreenshot(this.screenShotsData[0], 0);
	}

	previewScreenshot(screenshotObj: any, index: any): void {
		this.previewData = screenshotObj;
		this.activeIndex = index;
	}

	previewScreenShotInNewTab(imageURL: any): void {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}

	changePreviewScreenshot(activeIndex: any): void {
		if (activeIndex >= 0 && activeIndex < this.screenShotsData.length) {
			this.previewScreenshot(this.screenShotsData[activeIndex], activeIndex);
		}
	}
}
